import { namedRoutes as editRoutes } from "Catalog/Edit/routes"
import { namedRoutes as gridRoutes } from "Catalog/Grid/routes"
import { namedRoutes as previewRoutes } from "Catalog/Preview/routes"
import { CategoryId, ChargeId, DealId, DiscountId, OptionId, OptionListId, ProductId, SkuId } from "shared/hubrise/ids"

import { interpolatePath } from "./routes"

export type DisplayMode = "edit" | "grid" | "preview"

export type EditPage = "products" | "option_lists" | "deals" | "discounts" | "charges"

export type GridPage = "skus" | "options" | "deals"

const currentVariantRef = (): string | null => new URLSearchParams(location.search).get("variant_ref")

const currentAppInstanceId = (): string | null => new URLSearchParams(location.search).get("app_instance_id")

const withQueryParams = (
  path: string,
  options?: {
    variantRef?: string | null
  },
): string => {
  const queryParams = [`app_instance_id=${currentAppInstanceId()}`]

  const variantRef = options?.variantRef ?? currentVariantRef()
  if (variantRef !== null) {
    queryParams.push(`variant_ref=${variantRef}`)
  }

  return `${path}?${queryParams.join("&")}`
}

export const editPath = (
  catalogId: string,
  ...params:
    | ["products"]
    | ["product", ProductId]
    | ["category", CategoryId]
    | ["option_lists"]
    | ["option_list", OptionListId]
    | ["deals"]
    | ["deal", DealId]
    | ["discounts"]
    | ["discount", DiscountId]
    | ["charges"]
    | ["charge", ChargeId]
): string => {
  const [name, ...args] = params
  const { pathTemplate } = editRoutes[name]
  return withQueryParams(`/catalogs/${catalogId}/${interpolatePath(pathTemplate, args)}`)
}

export const gridPath = (
  catalogId: string,
  ...params: ["skus"] | ["sku", SkuId] | ["options"] | ["option", OptionId] | ["deals"] | ["deal", DealId]
): string => {
  const [name, ...args] = params
  const { pathTemplate } = gridRoutes[name]
  return withQueryParams(`/catalogs/${catalogId}/${interpolatePath(pathTemplate, args)}`)
}
export const previewPath = (
  catalogId: string,
  ...params: ["all"] | ["product", ProductId] | ["category", CategoryId] | ["deal", DealId]
): string => {
  const [name, ...args] = params
  const { pathTemplate } = previewRoutes[name]
  return withQueryParams(`/catalogs/${catalogId}/${interpolatePath(pathTemplate, args)}`)
}

export const imagePath = (catalogId: string, imageHrId: string): string => {
  return withQueryParams(`/images/${catalogId}/${imageHrId}`)
}

export const catalogPath = (catalogId: string, displayMode: DisplayMode): string => {
  switch (displayMode) {
    case "edit":
      return editPath(catalogId, "products")
    case "grid":
      return gridPath(catalogId, "skus")
    case "preview":
      return previewPath(catalogId, "all")
  }
}

export const changeVariantRefPath = (variantRef: string | null): string => {
  return withQueryParams(window.location.pathname, { variantRef: variantRef ?? "" })
}
